import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag';
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY, // サイトキーの設定
  loaderOptions: {
    autoHideBadge: true // reCAPTCHAバッチを非表示
  }
})
Vue.use(VueScrollTo, {
  duration: 1000,
  offset: 0
})
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router
})
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GTM_ID
  }
}, router);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
